import React from 'react';

import { ProductCarousel, ProductThumbnailLoader } from 'modules/catalogue/components';

export const CarrouselCatalogueLoader: React.FC = React.memo(() => (
    <ProductCarousel>
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
        <ProductThumbnailLoader />
    </ProductCarousel>
));
